import { G } from '@mobily/ts-belt';

import { useConnection } from '../../connection/hooks/useConnection';
import { useMutateDeleteOutletPhoto } from './useMutateDeleteOutletPhoto';
import { azureDelete, getAzureSignedLinkOutletPhotoDelete } from '../api';

export const useDeleteOutletPhoto = (propertyId: null | number) => {
  const {
    serialized2,
    id,
    isLoading: isLoadingUseConnection,
    isError: isErrorUseConnection,
  } = useConnection(propertyId);

  const {
    mutate,
    isLoading: isLoadingMutateDeleteOutletPhoto,
    isError: isErrorMutateDeleteOutletPhoto,
    isSuccess,
  } = useMutateDeleteOutletPhoto(propertyId);

  const deletePhoto = async (photoUrl: string, outletId: null | string) => {
    if (!outletId || !id || !propertyId) return;
    const { url, query, container } = await getAzureSignedLinkOutletPhotoDelete({
      outletId,
      connectionId: id,
      photoUrl,
    });

    const photoName = photoUrl.substring(photoUrl.lastIndexOf('/') + 1);

    await azureDelete(photoName, `${url}?${query}`, container);

    if (G.isNotNullable(serialized2) && G.isNotNullable(outletId)) {
      mutate({ outletId, propertyId, photoUrl });
    }
  };

  return {
    deletePhoto,
    isLoading: isLoadingUseConnection || isLoadingMutateDeleteOutletPhoto,
    isError: isErrorUseConnection || isErrorMutateDeleteOutletPhoto,
    isSuccess,
  };
};
